import { FC, useContext } from 'react';
import { DIALOG_PLACE_MARK_CLASS, useDialogSessionOptional } from '@/features/DialogSession';
import { formatMessageMarkLabel } from '../lib/commentMessageMarks';
import { MessageMarkTargetsContext } from '../model';

type Props = {
  /** Минута отправки в UTC — так, как записана в тексте комментария */
  sentAt: string;
};

/**
 * Метка места в переписке в тексте комментария: показывается во времени облаков переписки
 * и ведёт к первому элементу, отправленному в эту минуту.
 *
 * Метка, которой в переписке не соответствует ни один элемент, — текст. У диалога без переписки
 * запись вида метки — обычный текст и показывается как есть.
 */
export const MessageMarkLink: FC<Props> = ({ sentAt }) => {
  const targets = useContext(MessageMarkTargetsContext);
  const scrollToMessage = useDialogSessionOptional()?.scrollToMessage;

  if (!targets) return <>{`[${sentAt}]`}</>;

  const label = `[${formatMessageMarkLabel(sentAt)}]`;
  const messageId = targets.get(sentAt);
  if (messageId === undefined || !scrollToMessage) return <>{label}</>;

  return (
    <span role="button" tabIndex={-1} className={DIALOG_PLACE_MARK_CLASS} onClick={() => scrollToMessage(messageId)}>
      {label}
    </span>
  );
};
